import React, { useEffect } from "react";
//import { useHistory } from "react-router-dom";
import cx from "classnames";

import styles from "./MarketingBlock.module.scss";
import desktopImg from "../assets/img/2608_Miffy_Ecom_CustomerPortal_Desktop.webp";
import mobileImg from "../assets/img/2608_Miffy_Ecom_CustomerPortal_Mobile.webp";
import { getSubscriptions } from "./subscriptions/actions";
import { useDispatch, useSelector } from "react-redux";

const SHOW_MARKETING_BLOCK = false;

function MarketingBlock() {
    const dispatch = useDispatch();
    //const history = useHistory();

    const subscriptions = useSelector((s) => s.subscriptions.subscriptions);
    const subscription = subscriptions ? subscriptions.length : undefined;

    useEffect(() => {
        if (subscriptions) {
            return;
        }

        dispatch(getSubscriptions()).catch((error) => {
            console.error("Failed to fetch:", error);
        });
    }, [dispatch, subscriptions]);

    function handleClick() {
        //history.push("/subscriptions");
        window.location.href = "https://grind.co.uk/collections/grind-miffy";
    }

    if (SHOW_MARKETING_BLOCK && subscription > 0) {
        return (
            <section className={cx(styles.marketingBlock)}>
                <div className={cx(styles.content)}>
                    <h3>Don't miss the Miffy collab.</h3>
                    {/*<p>
                        Edit your subscription to try our new Honey Nut and
                        Sweet Miso coffee pods.
                    </p>*/}
                    <button onClick={handleClick}>Shop now</button>
                </div>

                <picture className={cx(styles.image)}>
                    <source media="(min-width: 768px)" srcSet={desktopImg} />
                    <img src={mobileImg} alt="flavor-img" />
                </picture>
            </section>
        );
    }
}

export default MarketingBlock;
